import { Action } from 'redux';
import { call, put } from '@redux-saga/core/effects';
import { CheckoutActions, CheckoutActionTypes } from '../checkout.types';
import { ACTION_CREATOR_NAME, errorToBasketErrorModel } from 'helpers';
import { ErrorAction } from '../../root.types';
import { BasketSagaReturnType } from 'store/sagaHelpers';
import { verifyEmailExistsSaga } from './verifyEmailExists';

export interface CheckEmailAction extends Action<CheckoutActionTypes.CHECK_EMAIL> {
    email: string;
}

export interface CheckEmailActionStart extends Action<CheckoutActionTypes.CHECK_EMAIL_START> {
}

export interface CheckEmailActionSuccess extends Action<CheckoutActionTypes.CHECK_EMAIL_SUCCESS> {
    userExists: boolean;
    email: string | null;
}

export interface CheckEmailActionError extends ErrorAction<CheckoutActionTypes.CHECK_EMAIL_ERROR> {
}

export const checkEmail: (email: string) => CheckEmailAction = (email: string) => ({
    type: CheckoutActionTypes.CHECK_EMAIL,
    email
});
checkEmail[ACTION_CREATOR_NAME] = 'checkEmail';

export type CheckEmailFunc = (...args: Parameters<typeof checkEmail>) => void;

export function* checkEmailSaga({ email }: CheckEmailAction): BasketSagaReturnType {
    yield put<CheckoutActions>({
        type: CheckoutActionTypes.CLEAR_EMAIL
    });

    yield put<CheckoutActions>({
        type: CheckoutActionTypes.CHECK_EMAIL_START
    });

    const result = yield call(verifyEmailExistsSaga, email);

    if (result.success) {
        yield put<CheckoutActions>({
            type: CheckoutActionTypes.CHECK_EMAIL_SUCCESS,
            userExists: result.userExists,
            email
        });

        return true;
    }

    yield put<CheckoutActions>({
        type: CheckoutActionTypes.CHECK_EMAIL_ERROR,
        error: errorToBasketErrorModel(result.error, 'checkEmailSaga')
    });

    return false;
}